export const blockIconsAudioandvideoFiberManualRecord = (
	<span className='material-symbols-outlined'>fiber_manual_record</span>
);
